export const navItems = [
  { id: 'hero', label: '首页' },
  { id: 'ranking', label: '热度排行' },
  { id: 'index', label: '主题索引' },
  { id: 'media', label: '精选视频' },
  { id: 'features', label: '网站特色' },
  { id: 'comments', label: '读者好评' },
  { id: 'contact', label: '联系我们' },
];

export const rankingData = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子，酒店同框照曝光引发全网热议', heat: '982.6万', tag: '爆', date: '2小时前' },
  { rank: 2, title: 'S+古装大剧官宣阵容，双顶流首次合作引爆期待值', heat: '756.3万', tag: '热', date: '5小时前' },
  { rank: 3, title: '某女团成员疑似恋情曝光，经纪公司紧急发声明回应', heat: '634.8万', tag: '热', date: '8小时前' },
  { rank: 4, title: '综艺节目录制现场突发意外，节目组发布致歉声明', heat: '521.4万', tag: '新', date: '10小时前' },
  { rank: 5, title: '知名导演新作定档暑期，预告片播放量破亿引发观影热潮', heat: '489.7万', tag: '新', date: '12小时前' },
  { rank: 6, title: '某品牌代言人翻车事件持续发酵，多个品牌宣布解约', heat: '378.2万', tag: '热', date: '1天前' },
  { rank: 7, title: '年度音乐盛典颁奖礼落幕，黑马选手横扫三项大奖', heat: '295.6万', tag: '', date: '1天前' },
];

export const appData = {
  title: '移动端专属入口',
  subtitle: '随时随地，吃瓜不停',
  description: '吃瓜网站移动端已全面适配手机浏览器访问，打开手机浏览器输入吃瓜网站最新线路地址，即可享受流畅的移动端吃瓜体验。支持iOS与Android全平台，随时随地掌握最新娱乐动态，不错过任何一个热点话题。',
  features: ['移动端专属优化', '省流量模式', '推送提醒', '夜间模式'],
};

export const updatesData = [
  { date: '2026-07-29', time: '14:30', content: '吃瓜网站线路一已完成服务器迁移升级，访问速度提升40%', type: '线路' },
  { date: '2026-07-29', time: '10:15', content: '新增备用入口线路三，进一步保障用户访问稳定性', type: '线路' },
  { date: '2026-07-28', time: '18:45', content: '首页界面全新改版上线，优化移动端浏览体验', type: '站点' },
  { date: '2026-07-28', time: '09:20', content: '吃瓜网站CDN节点扩容完成，全国访问延迟降低至30ms以内', type: '线路' },
  { date: '2026-07-27', time: '16:00', content: '安全防护系统升级，全面拦截恶意攻击保障用户访问安全', type: '安全' },
  { date: '2026-07-27', time: '11:30', content: '吃瓜网站在线观看功能优化，视频加载速度显著提升', type: '功能' },
  { date: '2026-07-26', time: '20:10', content: '新增海外线路支持，海外用户访问更稳定流畅', type: '线路' },
  { date: '2026-07-26', time: '14:55', content: '吃瓜网站首页入口防劫持技术升级，杜绝恶意跳转', type: '安全' },
  { date: '2026-07-25', time: '08:30', content: '吃瓜网站大全内容索引功能上线，一键直达热门话题', type: '功能' },
];

export const carouselData = [
  {
    title: '暑期档影视大盘点：十部必看热剧全面解析',
    excerpt: '2026年暑期档精彩纷呈，从古装权谋到现代悬疑，吃瓜网站为您整理十部口碑爆款，每部都值得熬夜追完。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20cinematic%20scene%20with%20film%20reel%20and%20spotlight%20on%20a%20warm%20dark%20stage%2C%20golden%20and%20crimson%20tones%2C%20artistic%20movie%20poster%20style%2C%20dramatic%20lighting%2C%20no%20text%2C%20elegant%20composition%20with%20soft%20gradients%20and%20theatrical%20atmosphere&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '影视盘点',
  },
  {
    title: '娱乐圈六月大事件回顾：那些刷屏的热搜话题',
    excerpt: '从恋情曝光到作品争议，吃瓜网站带你回顾六月最火爆的娱乐圈大事件，每一个都曾霸占热搜榜首。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20magazine%20cover%20layout%20with%20abstract%20geometric%20shapes%20in%20warm%20red%20and%20copper%20tones%2C%20editorial%20fashion%20photography%20style%2C%20glossy%20magazine%20aesthetic%2C%20elegant%20and%20modern%20composition%2C%20soft%20studio%20lighting%2C%20high-end%20editorial%20feel&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '月度回顾',
  },
  {
    title: '新生代艺人潜力榜：谁将成为下一个顶流',
    excerpt: '吃瓜网站独家盘点2026年最具潜力的新生代艺人，从演技到流量全面分析，预测娱乐圈下一个爆款明星。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20spotlight%20stage%20with%20rising%20stars%20silhouette%2C%20warm%20golden%20and%20amber%20lighting%2C%20elegant%20artistic%20rendering%2C%20award%20ceremony%20atmosphere%2C%20dramatic%20backlighting%2C%20sophisticated%20and%20glamorous%20composition&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '艺人盘点',
  },
  {
    title: '综艺节目新趋势：从竞技到慢综艺的转型之路',
    excerpt: '吃瓜网站深度分析当下综艺节目的内容转型趋势，慢综艺为何成为观众新宠？竞技类节目如何创新突围？',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20TV%20studio%20set%20with%20warm%20lighting%20and%20colorful%20stage%20design%2C%20entertainment%20show%20aesthetic%2C%20vibrant%20yet%20sophisticated%20colors%2C%20professional%20broadcast%20atmosphere%2C%20modern%20television%20production%20style%2C%20creative%20composition&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '行业分析',
  },
  {
    title: '音乐市场年中报告：数字专辑销量TOP10揭晓',
    excerpt: '吃瓜网站汇总2026上半年数字专辑销量数据，看看哪些歌手的作品最受欢迎，音乐市场格局发生了哪些变化。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20music%20studio%20scene%20with%20vinyl%20records%20and%20warm%20ambient%20lighting%2C%20retro%20modern%20fusion%20style%2C%20golden%20and%20deep%20red%20tones%2C%20artistic%20album%20cover%20aesthetic%2C%20elegant%20musical%20atmosphere%2C%20sophisticated%20composition&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '音乐榜单',
  },
  {
    title: '吃瓜网站线路稳定性报告：七月访问数据一览',
    excerpt: '吃瓜网站持续优化访问体验，七月线路稳定性达99.9%。查看本月各线路的详细访问数据和性能分析报告。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20tech%20dashboard%20with%20abstract%20data%20visualization%2C%20warm%20coral%20and%20emerald%20green%20accents%2C%20modern%20minimal%20tech%20aesthetic%2C%20clean%20geometric%20patterns%2C%20professional%20analytics%20atmosphere%2C%20sophisticated%20and%20trustworthy%20visual%20style&width=800&height=500&seq=carousel-06&orientation=landscape',
    tag: '站点报告',
  },
];

export const commentsData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20young%20person%20avatar%20in%20warm%20coral%20tones%2C%20simple%20minimal%20illustration%20style%2C%20clean%20background%2C%20soft%20friendly%20expression%2C%20modern%20flat%20design&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜群众小明',
    time: '3小时前',
    content: '终于找到稳定的吃瓜网站入口了！之前各种跳转广告真的烦，用了线路一后访问速度快了很多，给力！',
    likes: 1286,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20person%20avatar%20in%20warm%20amber%20tones%2C%20simple%20minimal%20illustration%20style%2C%20clean%20background%2C%20gentle%20smile%2C%20modern%20flat%20design&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '娱乐小达人',
    time: '6小时前',
    content: '吃瓜网站大全这个页面太实用了，把所有入口和线路都整理好了，再也不用到处找链接了，收藏了！',
    likes: 956,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20person%20avatar%20in%20warm%20green%20tones%2C%20simple%20minimal%20illustration%20style%2C%20clean%20background%2C%20confident%20expression%2C%20modern%20flat%20design&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '资深吃瓜人',
    time: '12小时前',
    content: '备用入口真的很重要！上次主线路维护的时候用了备用入口照样能看，这个设计太贴心了，推荐给身边朋友了。',
    likes: 723,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20person%20avatar%20in%20soft%20coral%20tones%2C%20simple%20minimal%20illustration%20style%2C%20clean%20background%2C%20happy%20expression%2C%20modern%20flat%20design&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '追料第一线',
    time: '1天前',
    content: '吃瓜网站在线观看体验越来越好了，视频加载很快不卡顿，移动端也能流畅使用，上班摸鱼必备哈哈！',
    likes: 548,
  },
];

export const faqData = [
  {
    q: '吃瓜网站线路一为什么有时打不开？',
    a: '吃瓜网站线路一作为主线路承载了最大的用户访问量，在高峰时段可能出现短暂的访问延迟。建议您同时收藏备用入口，当线路一拥堵时切换到备用线路即可正常访问。我们会持续监控各线路状态并及时优化。',
  },
  {
    q: '如何确保吃瓜网站在线观看的稳定性？',
    a: '建议您收藏吃瓜网站大全首页，这里汇集了所有官方线路与备用入口。当某一线路出现波动时，可立即切换至其他线路。同时请确保您的网络环境正常，推荐使用Chrome或Safari等主流浏览器访问。',
  },
  {
    q: '吃瓜网站入口是否需要注册才能使用？',
    a: '吃瓜网站首页入口完全免费开放，无需注册即可浏览全部内容。部分互动功能可能需要简单验证，但核心内容浏览不受任何限制。我们致力于为广大用户提供最便捷的访问体验。',
  },
  {
    q: '吃瓜网站最新线路从哪里获取？',
    a: '吃瓜网站最新线路会第一时间在本页面（吃瓜网站大全首页）进行更新。您可以将本页加入浏览器书签，或关注我们的官方社交媒体账号获取线路变更通知。我们承诺每次线路更新都会在本页同步公告。',
  },
];

export const cardsData = [
  {
    title: '热门话题实时追踪',
    excerpt: '覆盖娱乐圈、社会热点、综艺影视等全领域，吃瓜网站为您提供24小时不间断的热门话题更新，不错过任何一个精彩瞬间。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20newsroom%20scene%20with%20multiple%20screens%20showing%20trending%20topics%2C%20warm%20coral%20and%20soft%20white%20color%20scheme%2C%20modern%20minimal%20editorial%20style%2C%20clean%20and%20organized%20composition%2C%20professional%20media%20atmosphere&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '热点追踪',
    icon: 'ri-fire-line',
  },
  {
    title: '多条线路智能切换',
    excerpt: '吃瓜网站线路一与备用入口组成智能线路网络，当主线路不可用时自动推荐最优备用线路，保障您的访问永不中断。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20network%20connection%20diagram%20with%20nodes%20and%20links%20in%20warm%20coral%20and%20golden%20tones%2C%20modern%20tech%20minimal%20style%2C%20clean%20geometric%20design%2C%20abstract%20connectivity%20visualization&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '线路保障',
    icon: 'ri-link',
  },
  {
    title: '移动端完美适配',
    excerpt: '吃瓜网站在线观看全面支持手机浏览器访问，自适应不同屏幕尺寸，随时随地畅享流畅的吃瓜体验，让娱乐触手可及。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20smartphone%20displaying%20entertainment%20content%20with%20warm%20lighting%2C%20modern%20mobile%20UI%20aesthetic%2C%20clean%20minimal%20design%2C%20coral%20and%20white%20color%20scheme%2C%20cozy%20indoor%20setting&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '移动体验',
    icon: 'ri-smartphone-line',
  },
  {
    title: '安全防护全面升级',
    excerpt: '吃瓜网站首页入口采用多层安全防护机制，有效拦截恶意劫持和钓鱼攻击，确保您每次访问都安全可靠，放心浏览。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20shield%20and%20security%20concept%20with%20warm%20coral%20and%20emerald%20green%20accents%2C%20modern%20minimal%20design%2C%20abstract%20protection%20visualization%2C%20clean%20and%20trustworthy%20atmosphere&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '安全保障',
    icon: 'ri-shield-check-line',
  },
  {
    title: '每日更新海量内容',
    excerpt: '吃瓜网站大全每日更新数百条热门内容，涵盖明星动态、影视资讯、综艺八卦等多元领域，满足您的全方位吃瓜需求。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20content%20feed%20with%20colorful%20cards%20and%20thumbnails%2C%20warm%20coral%20and%20soft%20amber%20tones%2C%20modern%20editorial%20design%2C%20organized%20grid%20layout%2C%20vibrant%20yet%20clean%20composition&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '内容海量',
    icon: 'ri-stack-line',
  },
  {
    title: '社区氛围轻松愉快',
    excerpt: '吃瓜网站在线社区氛围轻松友好，和千万吃瓜群众一起讨论最新话题，分享观点，让吃瓜变成一种快乐的社交体验。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20community%20gathering%20concept%20with%20warm%20coral%20and%20golden%20tones%2C%20abstract%20people%20figures%20in%20harmonious%20circle%2C%20modern%20minimal%20illustration%20style%2C%20friendly%20and%20welcoming%20atmosphere&width=600&height=400&seq=card-06&orientation=landscape',
    tag: '社区氛围',
    icon: 'ri-group-line',
  },
];

export const mediaData = [
  {
    title: '六月娱乐圈大事件盘点：热搜背后的真相',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20stylized%20video%20thumbnail%20with%20entertainment%20news%20theme%2C%20warm%20coral%20and%20dark%20background%20contrast%2C%20modern%20YouTube%20thumbnail%20style%2C%20bold%20visual%20impact%2C%20professional%20media%20production%20aesthetic&width=640&height=360&seq=media-01&orientation=landscape',
    duration: '15:28',
    views: '128.6万',
    tag: '盘点',
  },
  {
    title: '顶流明星专访：不为人知的幕后故事',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20stylized%20interview%20scene%20with%20warm%20studio%20lighting%2C%20professional%20interview%20setup%2C%20coral%20and%20golden%20tones%2C%20modern%20talk%20show%20aesthetic%2C%20elegant%20studio%20atmosphere&width=640&height=360&seq=media-02&orientation=landscape',
    duration: '22:15',
    views: '95.3万',
    tag: '专访',
  },
  {
    title: '综艺名场面合集：那些笑到停不下来的瞬间',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20stylized%20variety%20show%20funny%20moment%20concept%20with%20warm%20vibrant%20colors%2C%20entertainment%20show%20aesthetic%2C%20playful%20and%20energetic%20composition%2C%20coral%20and%20amber%20color%20scheme&width=640&height=360&seq=media-03&orientation=landscape',
    duration: '08:42',
    views: '256.8万',
    tag: '搞笑',
  },
  {
    title: '新剧开播测评：这部S+大剧到底值不值得追',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20stylized%20drama%20review%20concept%20with%20cinematic%20lighting%2C%20warm%20coral%20and%20deep%20red%20tones%2C%20film%20critic%20aesthetic%2C%20professional%20review%20style%2C%20elegant%20cinematic%20atmosphere&width=640&height=360&seq=media-04&orientation=landscape',
    duration: '18:55',
    views: '187.4万',
    tag: '测评',
  },
  {
    title: '音乐现场精选：年度最佳舞台表演TOP20',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20stylized%20music%20concert%20stage%20with%20dramatic%20lighting%20and%20crowd%20silhouettes%2C%20warm%20golden%20and%20coral%20tones%2C%20live%20performance%20atmosphere%2C%20energetic%20and%20grand%20composition&width=640&height=360&seq=media-05&orientation=landscape',
    duration: '25:30',
    views: '312.1万',
    tag: '音乐',
  },
];

export const aboutData = {
  title: '关于吃瓜网站',
  paragraphs: [
    '吃瓜网站是深受广大用户喜爱的娱乐资讯导航平台，致力于为所有吃瓜群众提供稳定、快速、安全的访问入口。自上线以来，吃瓜网站始终坚持以用户体验为核心，不断优化线路质量与访问速度。',
    '我们深知在信息时代，稳定可靠的访问入口对用户的重要性。吃瓜网站线路一作为主线路，搭配多个备用入口，构建了完善的线路保障体系。无论您身在何处，使用何种设备，吃瓜网站在线入口都能为您提供流畅的浏览体验。',
    '吃瓜网站大全首页汇集了最新线路、热门话题、焦点专题等内容，让您一站式获取全部吃瓜资讯。我们承诺持续优化服务，守护每一位吃瓜群众的访问权益。',
  ],
  stats: [
    { value: '5000万+', label: '月活跃用户' },
    { value: '99.9%', label: '线路可用率' },
    { value: '7×24', label: '全天候运营' },
    { value: '3条', label: '备用线路' },
  ],
};

export const indexData = [
  { title: '明星动态', count: '12,856篇', description: '实时追踪明星最新行程、活动与社交动态', icon: 'ri-star-line' },
  { title: '影视资讯', count: '9,423篇', description: '最新电影、电视剧定档与播出信息汇总', icon: 'ri-film-line' },
  { title: '综艺八卦', count: '8,217篇', description: '热门综艺节目幕后花絮与嘉宾互动趣事', icon: 'ri-tv-line' },
  { title: '音乐现场', count: '6,845篇', description: '演唱会、音乐节与新专辑发布一手资讯', icon: 'ri-music-line' },
  { title: '时尚潮流', count: '5,932篇', description: '明星穿搭解析与时尚活动精彩回顾', icon: 'ri-shirt-line' },
  { title: '社会热点', count: '11,374篇', description: '与社会事件相关的娱乐话题深度讨论', icon: 'ri-global-line' },
  { title: '吃瓜社区', count: '15,608篇', description: '用户互动讨论区，畅聊最新热门话题', icon: 'ri-chat-1-line' },
  { title: '专题策划', count: '3,291篇', description: '编辑精选的深度专题与系列报道合集', icon: 'ri-article-line' },
  { title: '线路公告', count: '1,856篇', description: '吃瓜网站线路更新与维护公告及时推送', icon: 'ri-notification-line' },
];

export const featuresData = [
  {
    title: '多线路智能保障',
    description: '吃瓜网站线路一与备用入口组成智能网络，自动检测线路状态，当主线路异常时毫秒级切换至最优备用入口，确保访问零中断。',
    icon: 'ri-router-line',
  },
  {
    title: '全平台无缝适配',
    description: '吃瓜网站在线观看全面支持桌面端、移动端和平板设备，自适应不同屏幕尺寸和操作系统，无论何时何地都能获得一致优质体验。',
    icon: 'ri-device-line',
  },
  {
    title: '安全防护体系',
    description: '吃瓜网站首页入口搭载多层安全防护，包括DNS防劫持、HTTPS加密传输和恶意链接拦截，全方位保障您的访问安全与隐私。',
    icon: 'ri-safe-line',
  },
];

export const contactData = {
  title: '联系我们',
  description: '如果您在使用吃瓜网站过程中遇到任何问题，或有线路反馈、内容建议，欢迎通过以下方式与我们取得联系。我们重视每一位用户的反馈，致力于不断提升服务质量。',
  email: 'feedback@chigua.example.com',
  tips: [
    '线路反馈：如发现某条线路无法访问，请告知具体线路名称和错误现象',
    '内容建议：欢迎推荐您感兴趣的话题方向或内容类型',
    '安全举报：如发现仿冒或恶意网站，请及时举报协助我们处理',
  ],
};

export const topicsData = [
  { name: '吃瓜网站线路一', heat: '982万', color: 'primary' as const },
  { name: '暑期档大剧', heat: '756万', color: 'accent' as const },
  { name: '顶流恋情', heat: '634万', color: 'secondary' as const },
  { name: '综艺名场面', heat: '521万', color: 'primary' as const },
  { name: '吃瓜网站入口', heat: '489万', color: 'accent' as const },
  { name: '电影定档', heat: '378万', color: 'secondary' as const },
  { name: '吃瓜网站在线', heat: '312万', color: 'primary' as const },
  { name: '音乐盛典', heat: '295万', color: 'accent' as const },
  { name: '吃瓜网站大全', heat: '267万', color: 'secondary' as const },
  { name: '品牌代言', heat: '238万', color: 'primary' as const },
];

export const heroStats = [
  { value: '5000万+', label: '月活跃用户' },
  { value: '99.9%', label: '线路可用率' },
  { value: '3条', label: '备用线路保障' },
];